import { MethodDescription } from '../method-description';

export const ProductShopDetailsDescription = new MethodDescription();

ProductShopDetailsDescription.name = 'productShopDetails';
ProductShopDetailsDescription.fields = [
	'productId',
];
ProductShopDetailsDescription.usesToken = false;
